import { z } from 'zod';

// Must assign NEXT_PUBLIC_* env vars to a variable to force Next to inline them
const publicEnvObj = {
  NEXT_PUBLIC_SENTRY_ORG: process.env.NEXT_PUBLIC_SENTRY_ORG,
  NEXT_PUBLIC_SENTRY_PROJECT: process.env.NEXT_PUBLIC_SENTRY_PROJECT,
  NEXT_PUBLIC_SENTRY_URL: process.env.NEXT_PUBLIC_SENTRY_URL,
  NEXT_PUBLIC_SENTRY_RELEASE: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,

  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
  NEXT_PUBLIC_APP_TITLE: process.env.NEXT_PUBLIC_APP_TITLE,
  NEXT_PUBLIC_APP_URI: process.env.NEXT_PUBLIC_APP_URI,
  NEXT_PUBLIC_ACCOUNTS_URI: process.env.NEXT_PUBLIC_ACCOUNTS_URI,
  NEXT_PUBLIC_APP_V1_URI: process.env.NEXT_PUBLIC_APP_V1_URI,
  NEXT_PUBLIC_API_URI: process.env.NEXT_PUBLIC_API_URI,

  NEXT_PUBLIC_ASSET_PREFIX: process.env.NEXT_PUBLIC_ASSET_PREFIX,

  NEXT_PUBLIC_ENABLE_MOBILE_CONSOLE:
    process.env.NEXT_PUBLIC_ENABLE_MOBILE_CONSOLE,

  NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_KEY:
    process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_KEY,

  NEXT_PUBLIC_GTM_KEY: process.env.NEXT_PUBLIC_GTM_KEY,
  NEXT_PUBLIC_ENABLE_TRACKING_EVENT:
    process.env.NEXT_PUBLIC_ENABLE_TRACKING_EVENT,

  NEXT_PUBLIC_MAP_URI: process.env.NEXT_PUBLIC_MAP_URI,
  NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN,

  NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,

  NEXT_PUBLIC_FACEBOOK_CLIENT_ID: process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID,

  NEXT_PUBLIC_SOCKET_URL: process.env.NEXT_PUBLIC_SOCKET_URL,
  NEXT_PUBLIC_SOCKET_CLIENT_ID: process.env.NEXT_PUBLIC_SOCKET_CLIENT_ID,

  NEXT_PUBLIC_FINGERPRINT_KEY: process.env.NEXT_PUBLIC_FINGERPRINT_KEY,

  NEXT_PUBLIC_EP_API_URI: process.env.NEXT_PUBLIC_EP_API_URI,
  NEXT_PUBLIC_EP_API_KEY: process.env.NEXT_PUBLIC_EP_API_KEY,

  NEXT_PUBLIC_FRESH_CHAT_TOKEN: process.env.NEXT_PUBLIC_FRESH_CHAT_TOKEN,
  NEXT_PUBLIC_FRESH_CHAT_HOST: process.env.NEXT_PUBLIC_FRESH_CHAT_HOST,
  NEXT_PUBLIC_CHAT2BOOK_EMBED_URL: process.env.NEXT_PUBLIC_CHAT2BOOK_EMBED_URL,
  NEXT_PUBLIC_RO_NEXT_EMBED_URL: process.env.NEXT_PUBLIC_RO_NEXT_EMBED_URL,
};

export const publicEnv = z
  .object({
    NEXT_PUBLIC_SENTRY_ORG: z.string(),
    NEXT_PUBLIC_SENTRY_PROJECT: z.string(),
    NEXT_PUBLIC_SENTRY_URL: z.string(),
    NEXT_PUBLIC_SENTRY_RELEASE: z.string().optional(),
    NEXT_PUBLIC_SENTRY_DSN: z.string(),

    NEXT_PUBLIC_APP_ENV: z.string(),
    NEXT_PUBLIC_DOMAIN: z.string(),
    NEXT_PUBLIC_APP_TITLE: z.string(),
    NEXT_PUBLIC_APP_URI: z.string(),
    NEXT_PUBLIC_ACCOUNTS_URI: z.string(),
    NEXT_PUBLIC_APP_V1_URI: z.string(),
    NEXT_PUBLIC_API_URI: z.string(),

    NEXT_PUBLIC_ASSET_PREFIX: z.string().optional(),

    NEXT_PUBLIC_ENABLE_MOBILE_CONSOLE: z.string().optional(),

    NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_KEY: z.string(),

    NEXT_PUBLIC_GTM_KEY: z.string().optional(),
    NEXT_PUBLIC_ENABLE_TRACKING_EVENT: z.string(),

    NEXT_PUBLIC_MAP_URI: z.string(),
    NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN: z.string().optional(),

    NEXT_PUBLIC_GOOGLE_CLIENT_ID: z.string(),

    NEXT_PUBLIC_FACEBOOK_CLIENT_ID: z.string(),

    NEXT_PUBLIC_SOCKET_URL: z.string(),
    NEXT_PUBLIC_SOCKET_CLIENT_ID: z.string(),

    NEXT_PUBLIC_FINGERPRINT_KEY: z.string(),

    NEXT_PUBLIC_EP_API_URI: z.string(),
    NEXT_PUBLIC_EP_API_KEY: z.string(),

    NEXT_PUBLIC_FRESH_CHAT_TOKEN: z.string().optional(),
    NEXT_PUBLIC_FRESH_CHAT_HOST: z.string().optional(),
    NEXT_PUBLIC_CHAT2BOOK_EMBED_URL: z.string(),
    NEXT_PUBLIC_RO_NEXT_EMBED_URL: z.string(),
  })
  .parse(publicEnvObj);
